import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

/**
 * Asocia (idComponent number) o desasocia (idComponent null) un hallazgo a un
 * nodo del árbol de componentes. El backend valida que el componente pertenezca
 * al mismo ascensor del hallazgo.
 */
export async function setHallazgoComponentApi(idHallazgo, idComponent) {
  const { data } = await axios.patch(
    `${API_PATH}/actividades-hallazgo/${idHallazgo}/component`,
    { id_component: idComponent ?? null },
    { headers: authHeaders() }
  );
  return data;
}

/** Lista los hallazgos vinculados a un nodo de componente de un equipo. */
export async function getHallazgosByComponentApi(equipoId, nodeId) {
  const { data } = await axios.get(
    `${API_PATH}/ascensores/${equipoId}/components/${nodeId}/hallazgos`,
    { headers: authHeaders() }
  );
  return data; // { hallazgos: [...] }
}

/** Sugerencia de componente para un hallazgo según la actividad que lo originó. */
export async function getComponentSuggestionApi(idHallazgo) {
  const { data } = await axios.get(
    `${API_PATH}/actividades-hallazgo/${idHallazgo}/component-suggestion`,
    { headers: authHeaders() }
  );
  return data; // { suggestion: {id,name,node_type,score}|null, activityName }
}

/** Sugerencia de componente para una actividad+ascensor (flujo del técnico, antes de existir el hallazgo). */
export async function getComponentSuggestionByActivityApi(equipoId, activityId) {
  const { data } = await axios.get(`${API_PATH}/ascensores/${equipoId}/component-suggestion`, {
    params: { activityId },
    headers: authHeaders(),
  });
  return data; // { suggestion, via, activityName }
}
